import { ReactElement } from 'react';
import { required, SimpleForm, TextInput, ToolbarProps } from 'react-admin';

import { FormHeader } from 'src/client/components/forms/form-components';
import { formatDefaultTargetingForInput, parseDefaultTargetingText, validateDefaultTargetingJson } from './json';

type ProductFormProps = {
  title: string;
  toolbar?: ReactElement<ToolbarProps>;
};

export const ProductForm = ({ title, toolbar }: ProductFormProps) => (
  <SimpleForm toolbar={toolbar}>
    <FormHeader>{title}</FormHeader>
    <TextInput source="name" fullWidth validate={required()} />
    <TextInput source="externalPioId" label="External PIO ID" />
    <TextInput
      source="defaultTargeting"
      label="Default Targeting JSON"
      fullWidth
      multiline
      minRows={8}
      format={formatDefaultTargetingForInput}
      parse={parseDefaultTargetingText}
      validate={validateDefaultTargetingJson}
      helperText='Example: {"specialty": "cardiology"}'
    />
  </SimpleForm>
);
